//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheBlockHeader from "@/components/TheBlockHeader.vue";
import DonationsTableView from "@/components/objects/DonationsTableView.vue";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "DonationsListItem",
  components: { DonationsTableView, TheBlockHeader },
  provide: {
    source: 'objCharacteristics'
  },
  props: {
    label: {
      type: String
    },
    object_in_tooltip: {
      type: String
    },
    properties: {
      type: Array
    },
    limit: {
      type: Number,
      default: 5
    },
    objectLabel: {
      type: String
    },
    enableExport: {
      type: Boolean,
      default: true
    },
    user: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showFullCharacteristics: false,
      currentTemplate: null
    }
  },
  computed: {
    joinedProps() {
      const properties = [...this.properties];

      if (!this.showFullCharacteristics) {
        if (!properties.filter(x => x.is_short).length) return properties.slice(0, this.limit)
        return properties.filter(x => x.is_short).slice(0, this.limit)
      }
      return properties
    },
    isShowedDetailCharacteristicsButton() {
      const shorted = this.properties.filter(x => x.is_short)
      if (shorted.length) {
        return !(this.properties.length === shorted.length && shorted.length <= this.limit)
      } else {
        return this.properties.length > this.limit
      }
    },
    listInfo() {
      return {
        label: this.label,
        subLabel: this.sublabel || "",
        vistat_object: this.object_in_tooltip,
        object_label: this.objectLabel,
        id: this.id || uuidv4(),
      }
    }
  },
}
